<div class="header-bar">
  <div class="title-container">
    @if (icon) {
      <mat-icon>{{ icon }}</mat-icon>
    }
    <span class="title">{{ title }}</span>
  </div>
  <div class="actions">
    <ng-content></ng-content>
    @if (showBackButton) {
      <button
        mat-flat-button
        color="primary"
        (click)="back.emit()"
        [matTooltip]="backButtonLabel"
      >
        <mat-icon>keyboard_backspace</mat-icon>
        {{ backButtonLabel }}
      </button>
    }
  </div>
</div>
